// extracted by mini-css-extract-plugin
module.exports = {"recipes":"Recipes_recipes__2mzI1"};